var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    {
      attrs: {
        title: _vm.$t("businessOrders.warehouse.manualSelectionTitle"),
        "show-close": false,
        config: { focusFirst: false, closeToClick: false },
        "prevent-full-screen-modals": ""
      }
    },
    [
      _c("flex-row", { staticClass: "select-warehouse-text" }, [
        _c("div", [
          _vm._v(
            _vm._s(
              _vm.$t("businessOrders.warehouse.manualSelectionTextStatement")
            )
          )
        ])
      ]),
      _c("row", { staticClass: "select-warehouse-text" }, [
        _c("div", [
          _c("p", [
            _vm._v(
              " " +
                _vm._s(
                  _vm.$t("businessOrders.warehouse.manualSelectionTextQuestion")
                )
            )
          ])
        ])
      ]),
      _c("flex-row", { staticClass: "select-warehouse-buttons" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c(
              "base-button",
              {
                attrs: { id: "cancel", "for-modal": "" },
                on: { click: _vm.cancel }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("general.cancel")) +
                    "\n            "
                )
              ]
            ),
            _c(
              "base-button",
              {
                attrs: {
                  id: "select",
                  "for-modal": "",
                  disabled: _vm.isLoading
                },
                on: { click: _vm.select }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.$t("businessOrders.warehouse.manualSelectionProceed")
                    ) +
                    "\n            "
                )
              ]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }